<template>
  <!-- Modal -->
  <div>
    <div class="modal fade" ref="vuemodal" id="EditUserModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">{{ translations('navbar.account_setting') }}</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form :class="this.wasValidated ? 'was-validated' : ''">
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('account_setting.username') }}</h6>
                <input
                  type="text"
                  v-model="form.user_name"
                  v-validate="'required'"
                  data-vv-name="user_name"
                  data-vv-as="ユーザ名"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('account_setting.username_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('account_setting.gender') }}</h6>
                <select v-validate="'required'" data-vv-name="gender" data-vv-as="性別" class='form-control custom-select' v-model="form.gender" required>
                   <option v-for="(gender, i) in translationGender()" :key="i" :value='gender.id'>{{ gender.name }}</option>
                 </select>
                <div class="invalid-feedback">
                  {{ translations('account_setting.gender_required') }}
                </div>
              </div>
              <div class="form-group mb-3">
                <h6 class="font-weight-bold">{{ translations('account_setting.birthday') }}</h6>
                <input
                  type="date"
                  v-model="form.birthday"
                  v-validate="'required'"
                  data-vv-name="birthday"
                  data-vv-as="誕生日"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  {{ translations('account_setting.birthday_required') }}
                </div>
              </div>
<!--               <div class="form-group mb-3">
                <h6 class="font-weight-bold">権限</h6>
                <input
                  type="text"
                  v-model="form.user_privilege"
                  v-validate="'required'"
                  data-vv-name="user_privilege"
                  data-vv-as="権限"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  権限は必須です。
                </div>
              </div> -->
<!--               <div class="form-group mb-3">
                <h6 class="font-weight-bold">メールアドレス</h6>
                <input
                  type="text"
                  v-model="form.email"
                  v-validate="'required'"
                  data-vv-name="email"
                  data-vv-as="メールアドレス"
                  class="form-control"
                  required
                >
                <div class="invalid-feedback">
                  メールアドレスは必須です。
                </div>
              </div> -->
            </form>
          </div>
          <div class="modal-footer">
            <div>
              <button ref="closeEditUserModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>&nbsp;
              <button type="submit" class="btn btn-primary" v-on:click="validateBeforeUpdate">{{ translations('common.update') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EditUserModal',
  props: {},
  data () {
    return {
      form: {},
      genders: [{ id: 1, name: '男性' }, { id: 2, name: '女性' }, { id: 3, name: 'その他' }],
      wasValidated: false,
      isLoading: false
    }
  },
  created: async function () {
    this.isLoading = true
    this.form = JSON.parse(JSON.stringify(this.$store.getters['User/data']))
  },
  mounted () {
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    validateBeforeUpdate: function () {
      var self = this
      self.$validator
        .validateAll()
        .then(function (response) {
          if (response === true) {
            self.updateUser()
          }
          self.wasValidated = true
        })
        .catch(function (e) {
          // Catch errors
        })
    },

    async updateUser () {
      var self = this
      try {
        self.isLoading = true

        let params = {
          user_id: self.$store.getters['User/id'],
          user_name: self.form.user_name,
          gender: self.form.gender,
          birthday: self.form.birthday
          // user_privilege_id: self.form.user_privilege_id,
          // user_privilege: self.form.user_privilege,
          // email: self.form.email
        }
        let result = await this.$http.post(this.$api_url.account_details_update, params)
        if (result.data.status === true) {
          self.$store.dispatch('User/update', params).then(function () {
            self.$toastr.info('アカウントの設定が完了しました。', '完了')
            window.$('#EditUserModal').modal('hide')
          })
        } else {
          self.$toastr.error(result.data.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:details_update:catch(error): ', error)
      }
    },

    translationGender () {
      return this.genders.map(gender => ({
        ...gender,
        name: this.translations(`gender.${gender.id}`)
      }))
    }
  }
}
</script>
